import _ from 'lodash';

/**
 * @param {Object} initialState
 * @param {Object} actionHandlers
 * @param {Object} [actionHandlersRegex]
 * @returns {Function} reducer - that takes state and action and returns new state either
 * created from invoked action or from previous state if no match is found. Action handler
 * is looked for in actionHandlers. If no exact match is found then it attempts to find find
 * action handler match in actionHandlersRegex
 */
export default function createReducer(initialState, actionHandlers, actionHandlersRegex) {
    return (state = initialState, action) => {
        const internalState = state;
        let handler = actionHandlers[action.type];

        // No exact match was found and regex rules are specified
        if (!handler && actionHandlersRegex) {
            // Attempt to find match using regex
            handler = _.find(actionHandlersRegex, (handlerCandidate, pattern) => {
                if (action && action.type && action.type.match(new RegExp(pattern))) {
                    return handlerCandidate;
                }
                return null;
            });
        }

        if (handler) {
            return handler(internalState, action);
        }

        return internalState;
    };
}
